import { render, staticRenderFns } from "./FormSetup.vue?vue&type=template&id=6834a5b2"
import script from "./FormSetup.vue?vue&type=script&lang=js"
export * from "./FormSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports